<div id="app" class="app" [dir]="(settings.rtl) ? 'rtl' : 'ltr'" [ngClass]="[settings.theme, 'toolbar']" [class.main-toolbar-fixed]="settings.mainToolbarFixed">
  @if (maintenanceMode) {
  <div  class="overlay flex-col justify-center items-center text-bold text-xl">
    <mat-card><div class="m-5 text-center">foreclosureauctions.com <br/> is under maintenance for a few minutes. <br/> We will be back shortly.</div></mat-card>
  </div>
}
  @else {
    <router-outlet></router-outlet>
  }
  <ng-progress [spinner]="false" color="#e91e63"></ng-progress>
</div>


